import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const FollowUpTextAreaQuestion = ({ question, disabled, onAnswerChange }) => {
  const rdn = Math.random();
  const [value, setValue] = useState(question.answer.value);

  return (
    <div className="o-follow-up-question o-follow-up-question--vertical">
      <div className="o-follow-up-question__line">
        <div className="o-follow-up-question__checkbox">
        </div>

        <div className="o-follow-up-question__label">
          <label htmlFor={`input-${rdn}`}>{question.title}</label>
        </div>
      </div>

      <div className="o-follow-up-question__field o-follow-up-question__field--full">
        <textarea
          rows={4}
          disabled={disabled}
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            question.answer.value = event.target.value;
            if (onAnswerChange) onAnswerChange();
          }}
        />
      </div>
    </div>
  )
}

FollowUpTextAreaQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func,
}
